import { createDraftSafeSelector } from '@reduxjs/toolkit';
import {  DashboardSyncSettings, WidgetConfig, WidgetDashboardConfig } from '../components/widgetDashboard/widgetDashboard.interface';
import { WidgetDashboardStateType } from '../reducer/widgetDashboard.reducer';
import {RootState} from '../store';

const state = (state: RootState) => state

export const selectAllLayouts = (store: RootState) => store.widgetDashboardStore.layouts as WidgetDashboardStateType['layouts'];

export const selectLayout = (id: string) => (store: RootState) => store.widgetDashboardStore.layouts[id]  as WidgetDashboardConfig

export const selectLayoutPanes = (id: string) => (store: RootState) => store.widgetDashboardStore.layouts[id]?.panes  as WidgetDashboardConfig['panes']

export const selectLayoutWidgets = (id: string) => createDraftSafeSelector(state, (store: RootState) => (store.widgetDashboardStore.layouts[id]?.widgets || {}) as WidgetDashboardConfig['widgets'])

export const selectActiveWidget = (id: string) => (store: RootState) => {
    const dashboard: WidgetDashboardConfig = store.widgetDashboardStore.layouts[id];
    if (!dashboard) return null;
    const widgets = dashboard.widgets;
    if (!widgets) return null;

    return dashboard.activeWidget ? widgets[dashboard.activeWidget] as WidgetConfig<any> : null
}

export const selectSyncSettings = (id: string) => createDraftSafeSelector(state, (store: RootState) => (store.widgetDashboardStore.layouts[id]?.syncSettings || {}) as DashboardSyncSettings)